module.exports = __webpack_public_path__ + "img/banner_chn.1c2cdb05.png";